import Icon from '../components/Icon.vue'

Icon.register({
  mitten: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M368 416c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-320c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16h320zM425 206.9c27.1 22.6 30.8 62.9 8.1 90.1l-72.5 87h-309l-47.9-207.6c-17.9-77.5 30.5-154.8 107.9-172.7 77.4-17.9 154.8 30.5 172.8 108l29.6 128.4 20.9-25c22.6-27.2 62.9-30.8 90.1-8.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/mitten.js
// module id = 1574
// module chunks = 0